import { Flex } from '@conteg/ui';
import OneTimePassword, {
  OneTimePasswordProps,
} from 'pages/storage-unit-detail/components/actions/one-time-password/one-time-password';

import ConfirmPickupReservation from '../confirm-pickup-reservation';

type ShowOneTimePasswordProps = {
  storageUnitId: string;
  storageUnitCount: number;
  oneTimePassword: OneTimePasswordProps;
};

const ShowOneTimePassword = ({
  storageUnitId,
  storageUnitCount,
  oneTimePassword,
}: ShowOneTimePasswordProps) => {
  return (
    <Flex gap="8rem" flexDirection="column" alignItems="center">
      <OneTimePassword {...oneTimePassword} />
      <ConfirmPickupReservation
        storageUnitId={storageUnitId}
        storageUnitCount={storageUnitCount}
      />
    </Flex>
  );
};

export default ShowOneTimePassword;
